// extracted by mini-css-extract-plugin
export default {"offersContainer":"styles_offersContainer__kUOzQ"};